import React from "react";
import Grid from "@material-ui/core/Grid";

import styles from "./size-info.module.scss";
import image from "../../../assets/images/size-info/skirt.png";

function PencilSkirt() {
  return (
    <Grid container className={styles.sizeInfo}>
      <Grid item xs={12}>
        <h2 className={styles.sizeInfoTitle}>
          Возьмите Вашу любимую облегающую юбку и проведите измерения:
        </h2>
      </Grid>
      <Grid item xs={12} md={4} className={styles.sizeInfoImage}>
        <img src={image} />
      </Grid>
      <Grid item xs={12} md={8}>
        <ol>
          <li>Измерьте ширину пояса Вашей юбки (в см).</li>
          <li>Измерьте ширину в бёдрах (в см).</li>
          <li>Измерьте ширину низа Вашей юбки (в см).</li>
          <li>
            Измерьте длину от Вашей талии до отметки чуть ниже колен (в см).
          </li>
          <li>
            В нашей таблице размеров найдите показатели, которые наиболее точно
            соответствуют получившимся цифрам.
          </li>
        </ol>
        <p>
          Если у Вас нет облегающей юбки для снятия мерок, то можно измерить
          обхват талии, бёдер и ног под коленями и разделить этот результат на
          2, затем прибавив 1-2 см к получившемуся.
        </p>
      </Grid>
    </Grid>
  );
}

PencilSkirt.propTypes = {};

export default PencilSkirt;
